export const environment = {
  production: true,
  defaultLanguage: 'es',

  // endPointService: "http://localhost:8080",
  // camerasEnabled: true,

  // endPointService: "https://localhost:44375",
  endPointService: "https://api.winco.dev.idimedical.com",
  // endPointService: "https://api.winco.rel.idimedical.com",
  camerasEnabled: false,

  regPerPage: 100000,
  guidEmpty: '00000000-0000-0000-0000-000000000000',
  product: "49D2FD56-6CE3-44EC-A05D-6C0963B751A8",
  delayOperation: 100,
  maxExerciseRepeat: 80,
  overTime: 120,
  minLimitTimePercent: 60
};
